export default {
  items: [
    {
      key: '1',
      name: 'Common 通用化 API'
    }
  ],
  itemMap: {
    '1': [
      {
        key: '101',
        name: '1. 方案简介',
        url: '/common/introduce'
      },
      {
        key: '102',
        name: '2. 试用场景',
        url: '/common/usage'
      },
      {
        key: '103',
        name: '3. 接入文档',
        url: '/common/docs'
      }
    ]
  }
}